var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/@shopify/theme-currency/dist/currency.cjs.js
var require_currency_cjs = __commonJS({
  "node_modules/@shopify/theme-currency/dist/currency.cjs.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.formatMoney = formatMoney2;
    var moneyFormat = "${{amount}}";
    function formatMoney2(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;
      function formatWithDelimiters(number) {
        var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
        var thousands = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
        var decimal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".";
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100).toFixed(precision);
        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
  }
});

// node_modules/@shopify/theme-a11y/theme-a11y.js
function forceFocus(element, options) {
  options = options || {};
  var savedTabIndex = element.tabIndex;
  element.tabIndex = -1;
  element.dataset.tabIndex = savedTabIndex;
  element.focus();
  if (typeof options.className !== "undefined") {
    element.classList.add(options.className);
  }
  element.addEventListener("blur", callback);
  function callback(event) {
    event.target.removeEventListener(event.type, callback);
    element.tabIndex = savedTabIndex;
    delete element.dataset.tabIndex;
    if (typeof options.className !== "undefined") {
      element.classList.remove(options.className);
    }
  }
}

// src/scripts/templates/product.js
var import_theme_currency = __toESM(require_currency_cjs());

// node_modules/@shopify/theme-product-form/listeners.js
function Listeners() {
  this.entries = [];
}
Listeners.prototype.add = function(element, event, fn) {
  this.entries.push({ element, event, fn });
  element.addEventListener(event, fn);
};
Listeners.prototype.removeAll = function() {
  this.entries = this.entries.filter(function(listener) {
    listener.element.removeEventListener(listener.event, listener.fn);
    return false;
  });
};

// node_modules/@shopify/theme-product/theme-product.js
function getVariantFromSerializedArray(product, collection) {
  _validateProductStructure(product);
  var optionArray = _createOptionArrayFromOptionCollection(product, collection);
  return getVariantFromOptionArray(product, optionArray);
}
function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);
  var result = product.variants.filter(function(variant) {
    return options.every(function(option, index) {
      return variant.options[index] === option;
    });
  });
  return result[0] || null;
}
function _createOptionArrayFromOptionCollection(product, collection) {
  _validateProductStructure(product);
  _validateSerializedArray(collection);
  var optionArray = [];
  collection.forEach(function(option) {
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
        optionArray[i] = option.value;
        break;
      }
    }
  });
  return optionArray;
}
function _validateProductStructure(product) {
  if (typeof product !== "object") {
    throw new TypeError(product + "is not an object.");
  }
  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + "is empty.");
  }
}
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) {
    throw new TypeError(collection + "is not an array.");
  }
  if (collection.length === 0) {
    throw new Error(collection + "is empty.");
  }
  if (collection[0].hasOwnProperty("name")) {
    if (typeof collection[0].name !== "string") {
      throw new TypeError(
        "Invalid value type passed for name of option " + collection[0].name + ". Value should be string."
      );
    }
  } else {
    throw new Error(collection[0] + "does not contain name key.");
  }
}
function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === "object") {
    throw new Error(options + "is not a valid array of options.");
  }
}

// node_modules/@shopify/theme-product-form/theme-product-form.js
var selectors = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: '[name="quantity"]',
  propertyInput: '[name^="properties"]'
};
function getUrlWithVariant(url, id) {
  if (/variant=/.test(url)) {
    return url.replace(/(variant=)[^&]+/, "$1" + id);
  } else if (/\?/.test(url)) {
    return url.concat("&variant=").concat(id);
  }
  return url.concat("?variant=").concat(id);
}
function ProductForm(element, product, options) {
  this.element = element;
  this.product = _validateProductObject(product);
  options = options || {};
  this._listeners = new Listeners();
  this._listeners.add(
    this.element,
    "submit",
    this._onSubmit.bind(this, options)
  );
  this.optionInputs = this._initInputs(
    selectors.optionInput,
    options.onOptionChange
  );
  this.quantityInputs = this._initInputs(
    selectors.quantityInput,
    options.onQuantityChange
  );
  this.propertyInputs = this._initInputs(
    selectors.propertyInput,
    options.onPropertyChange
  );
}
ProductForm.prototype.destroy = function() {
  this._listeners.removeAll();
};
ProductForm.prototype.options = function() {
  return _serializeOptionValues(this.optionInputs, function(item) {
    var regex = /(?:^(options\[))(.*?)(?:\])/;
    item.name = regex.exec(item.name)[2];
    return item;
  });
};
ProductForm.prototype.variant = function() {
  return getVariantFromSerializedArray(this.product, this.options());
};
ProductForm.prototype.properties = function() {
  var properties = _serializePropertyValues(this.propertyInputs, function(propertyName) {
    var regex = /(?:^(properties\[))(.*?)(?:\])/;
    var name = regex.exec(propertyName)[2];
    return name;
  });
  return Object.entries(properties).length === 0 ? null : properties;
};
ProductForm.prototype.quantity = function() {
  return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
};
ProductForm.prototype._setIdInputValue = function(value) {
  var idInputElement = this.element.querySelector(selectors.idInput);
  if (!idInputElement) {
    idInputElement = document.createElement("input");
    idInputElement.type = "hidden";
    idInputElement.name = "id";
    this.element.appendChild(idInputElement);
  }
  idInputElement.value = value.toString();
};
ProductForm.prototype._onSubmit = function(options, event) {
  event.dataset = this._getProductFormEventData();
  this._setIdInputValue(event.dataset.variant.id);
  if (options.onFormSubmit) {
    options.onFormSubmit(event);
  }
};
ProductForm.prototype._onFormEvent = function(cb) {
  if (typeof cb === "undefined") {
    return Function.prototype;
  }
  return function(event) {
    event.dataset = this._getProductFormEventData();
    cb(event);
  }.bind(this);
};
ProductForm.prototype._initInputs = function(selector, cb) {
  var elements = Array.prototype.slice.call(
    this.element.querySelectorAll(selector)
  );
  return elements.map(
    function(element) {
      this._listeners.add(element, "change", this._onFormEvent(cb));
      return element;
    }.bind(this)
  );
};
ProductForm.prototype._getProductFormEventData = function() {
  return {
    options: this.options(),
    variant: this.variant(),
    properties: this.properties(),
    quantity: this.quantity()
  };
};
function _serializeOptionValues(inputs, transform) {
  return inputs.reduce(function(options, input) {
    if (input.checked || // If input is a checked (means type radio or checkbox)
    input.type !== "radio" && input.type !== "checkbox") {
      options.push(transform({ name: input.name, value: input.value }));
    }
    return options;
  }, []);
}
function _serializePropertyValues(inputs, transform) {
  return inputs.reduce(function(properties, input) {
    if (input.checked || // If input is a checked (means type radio or checkbox)
    input.type !== "radio" && input.type !== "checkbox") {
      properties[transform(input.name)] = input.value;
    }
    return properties;
  }, {});
}
function _validateProductObject(product) {
  if (typeof product !== "object") {
    throw new TypeError(product + " is not an object.");
  }
  if (typeof product.variants[0].options === "undefined") {
    throw new TypeError(
      "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
    );
  }
  return product;
}

// node_modules/@shopify/theme-sections/section.js
var SECTION_ID_ATTR = "data-section-id";
function Section(container, properties) {
  this.container = validateContainerElement(container);
  this.id = container.getAttribute(SECTION_ID_ATTR);
  this.extensions = [];
  Object.assign(this, validatePropertiesObject(properties));
  this.onLoad();
}
Section.prototype = {
  onLoad: Function.prototype,
  onUnload: Function.prototype,
  onSelect: Function.prototype,
  onDeselect: Function.prototype,
  onBlockSelect: Function.prototype,
  onBlockDeselect: Function.prototype,
  extend: function extend(extension) {
    this.extensions.push(extension);
    var extensionClone = Object.assign({}, extension);
    delete extensionClone.init;
    Object.assign(this, extensionClone);
    if (typeof extension.init === "function") {
      extension.init.apply(this);
    }
  }
};
function validateContainerElement(container) {
  if (!(container instanceof Element)) {
    throw new TypeError(
      "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
    );
  }
  if (container.getAttribute(SECTION_ID_ATTR) === null) {
    throw new Error(
      "Theme Sections: The section container provided does not have an id assigned to the " + SECTION_ID_ATTR + " attribute."
    );
  }
  return container;
}
function validatePropertiesObject(value) {
  if (typeof value !== "undefined" && typeof value !== "object" || value === null) {
    throw new TypeError(
      "Theme Sections: The properties object provided is not a valid"
    );
  }
  return value;
}
if (typeof Object.assign != "function") {
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
      "use strict";
      if (target == null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      var to = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];
        if (nextSource != null) {
          for (var nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

// node_modules/@shopify/theme-sections/theme-sections.js
var SECTION_TYPE_ATTR = "data-section-type";
var SECTION_ID_ATTR2 = "data-section-id";
window.Shopify = window.Shopify || {};
window.Shopify.theme = window.Shopify.theme || {};
window.Shopify.theme.sections = window.Shopify.theme.sections || {};
var registered = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
var instances = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
function register(type, properties) {
  if (typeof type !== "string") {
    throw new TypeError(
      "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
    );
  }
  if (typeof registered[type] !== "undefined") {
    throw new Error(
      'Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice'
    );
  }
  function TypedSection(container) {
    Section.call(this, container, properties);
  }
  TypedSection.constructor = Section;
  TypedSection.prototype = Object.create(Section.prototype);
  TypedSection.prototype.type = type;
  return registered[type] = TypedSection;
}
function load(types, containers) {
  types = normalizeType(types);
  if (typeof containers === "undefined") {
    containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
  }
  containers = normalizeContainers(containers);
  types.forEach(function(type) {
    var TypedSection = registered[type];
    if (typeof TypedSection === "undefined") {
      return;
    }
    containers = containers.filter(function(container) {
      if (isInstance(container)) {
        return false;
      }
      if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
        return false;
      }
      if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
        return true;
      }
      instances.push(new TypedSection(container));
      return false;
    });
  });
}
function unload(selector) {
  var instancesToUnload = getInstances(selector);
  instancesToUnload.forEach(function(instance) {
    var index = instances.map(function(e) {
      return e.id;
    }).indexOf(instance.id);
    instances.splice(index, 1);
    instance.onUnload();
  });
}
function getInstances(selector) {
  var filteredInstances = [];
  if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
    var firstElement = selector[0];
  }
  if (selector instanceof Element || firstElement instanceof Element) {
    var containers = normalizeContainers(selector);
    containers.forEach(function(container) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.container === container;
        })
      );
    });
  } else if (typeof selector === "string" || typeof firstElement === "string") {
    var types = normalizeType(selector);
    types.forEach(function(type) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.type === type;
        })
      );
    });
  }
  return filteredInstances;
}
function getInstanceById(id) {
  var instance;
  for (var i = 0; i < instances.length; i++) {
    if (instances[i].id === id) {
      instance = instances[i];
      break;
    }
  }
  return instance;
}
function isInstance(selector) {
  return getInstances(selector).length > 0;
}
function normalizeType(types) {
  if (types === "*") {
    types = Object.keys(registered);
  } else if (typeof types === "string") {
    types = [types];
  } else if (types.constructor === Section) {
    types = [types.prototype.type];
  } else if (Array.isArray(types) && types[0].constructor === Section) {
    types = types.map(function(TypedSection) {
      return TypedSection.prototype.type;
    });
  }
  types = types.map(function(type) {
    return type.toLowerCase();
  });
  return types;
}
function normalizeContainers(containers) {
  if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
    containers = Array.prototype.slice.call(containers);
  } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
    containers = [];
  } else if (containers === null) {
    containers = [];
  } else if (!Array.isArray(containers) && containers instanceof Element) {
    containers = [containers];
  }
  return containers;
}
if (window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      "[" + SECTION_ID_ATTR2 + '="' + id + '"]'
    );
    if (container !== null) {
      load(container.getAttribute(SECTION_TYPE_ATTR), container);
    }
  });
  document.addEventListener("shopify:section:unload", function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      "[" + SECTION_ID_ATTR2 + '="' + id + '"]'
    );
    var instance = getInstances(container)[0];
    if (typeof instance === "object") {
      unload(container);
    }
  });
  document.addEventListener("shopify:section:select", function(event) {
    var instance = getInstanceById(event.detail.sectionId);
    if (typeof instance === "object") {
      instance.onSelect(event.detail.load);
    }
  });
  document.addEventListener("shopify:section:deselect", function(event) {
    var instance = getInstanceById(event.detail.sectionId);
    if (typeof instance === "object") {
      instance.onDeselect();
    }
  });
  document.addEventListener("shopify:block:select", function(event) {
    var instance = getInstanceById(event.detail.sectionId);
    if (typeof instance === "object") {
      instance.onBlockSelect(event.detail.blockId, event.detail.load);
    }
  });
  document.addEventListener("shopify:block:deselect", function(event) {
    var instance = getInstanceById(event.detail.sectionId);
    if (typeof instance === "object") {
      instance.onBlockDeselect(event.detail.blockId);
    }
  });
}

// src/scripts/templates/product.js
var classes = { hide: "hide" };
var keyboardKeys = { ENTER: 13 };
var selectors2 = {
  submitButton: "[data-submit-button]",
  submitButtonText: "[data-submit-button-text]",
  comparePrice: "[data-compare-price]",
  comparePriceText: "[data-compare-text]",
  priceWrapper: "[data-price-wrapper]",
  imageWrapper: "[data-product-image-wrapper]",
  visibleImageWrapper: `[data-product-image-wrapper]:not(.${classes.hide})`,
  imageWrapperById: (id) => `${selectors2.imageWrapper}[data-image-id='${id}']`,
  productForm: "[data-product-form]",
  productPrice: "[data-product-price]",
  thumbnail: "[data-product-single-thumbnail]",
  thumbnailById: (id) => `[data-thumbnail-id='${id}']`,
  thumbnailActive: "[data-product-single-thumbnail][aria-current]"
};
register("product", {
  async onLoad() {
    const productFormElement = document.querySelector(selectors2.productForm);
    this.cartMax = $('section[data-section-type="product"]').data("cart-max");
    this.product = await this.getProductJson(
      productFormElement.dataset.productHandle
    );
    this.cart = await this.getCartJson();
    this.productForm = new ProductForm(productFormElement, this.product, {
      onOptionChange: this.onFormOptionChange.bind(this)
    });
    this.enforceMaxCart = this.enforceMaxCart.bind(this);
    this.addItemToCart = this.addItemToCart.bind(this);
    this.getCartJson = this.getCartJson.bind(this);
    this.container.addEventListener("submit", this.addItemToCart);
    $("[data-product-slick]").slick({
      infinite: false,
      dots: false,
      arrows: false,
      slidesToShow: 1,
      asNavFor: $("[data-thumbnail-slick]"),
      variableWidth: false
    });
    $("[data-thumbnail-slick]").slick({
      infinite: false,
      dots: false,
      arrows: false,
      asNavFor: $("[data-product-slick]"),
      slidesToShow: 5,
      focusOnSelect: true,
      vertical: false,
      responsive: [
        {
          breakpoint: 680,
          settings: {
            vertical: false
          }
        }
      ]
    });
    const currentSlide = $("[data-thumbnail-slick]").slick("slickCurrentSlide");
    $("[data-thumbnail-slick]").find('[data-slick-index="' + currentSlide + '"]').addClass("active");
    $("[data-thumbnail-slick]").on(
      "afterChange",
      function(event, slick, currentSlide2, nextSlide) {
        $("[data-thumbnail-slick]").find(".slick-slide").removeClass("active");
        $("[data-thumbnail-slick]").find('[data-slick-index="' + currentSlide2 + '"]').addClass("active");
      }
    );
    $(".product-qtyminus").on("click", (e) => {
      this.productQuantityModify(e, -1);
    });
    $(".product-qtyplus").on("click", (e) => {
      this.productQuantityModify(e, 1);
    });
  },
  message() {
    return alert(
      `So sorry. We're uable to sell more than ${this.cartMax} of this product at a time. We're unable to add this to the cart.`
    );
  },
  async enforceMaxCart(qty) {
    if (!this.cartMax)
      return true;
    const cart = await this.getCartJson();
    const productInCart = cart.items.find(
      (item) => item.product_id === this.product.id
    );
    if (productInCart) {
      const itemQty = productInCart.quantity;
      const moreThanMax = itemQty >= this.cartMax;
      const toBeMoreThanMax = itemQty + qty > this.cartMax;
      if (moreThanMax || toBeMoreThanMax) {
        return false;
      }
    }
    return true;
  },
  onUnload() {
    this.productForm.destroy();
  },
  async getProductJson(handle) {
  return fetch(`/products/${handle}.js`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then(text => {
      if (!text) {
        throw new Error("Empty response received");
      }
      try {
        return JSON.parse(text);
      } catch (error) {
        console.error("Error parsing JSON:", error);
        throw error;
      }
    })
    .catch((error) => {
      console.error("Error fetching product JSON:", error);
      throw error;
    });
},
  async getCartJson() {
    return fetch(window.Shopify.routes.root + "cart.js").then(
      (response) => response.json()
    );
  },
  async productQuantityModify(e, modifier) {
    e.preventDefault();
    const $quantity = $('input[name="quantity"]');
    const currentQuanttiy = parseInt($quantity.val());
    let newQuantity = currentQuanttiy + modifier;
    let maxVal = 10;
    newQuantity = newQuantity != -1 ? newQuantity : 0;
    if (newQuantity > 0 && newQuantity <= maxVal) {
      $quantity.attr("value", newQuantity);
    }
  },
  onFormOptionChange(event) {
    const variant = event.dataset.variant;
    this.renderImages(variant);
    this.renderPrice(variant);
    this.renderComparePrice(variant);
    this.renderSubmitButton(variant);
    this.updateBrowserHistory(variant);
  },
  onThumbnailClick(event) {
    event.preventDefault();
    const thumbnail = event.target.closest(selectors2.thumbnail);
    if (!thumbnail)
      return;
    this.renderFeaturedImage(thumbnail.dataset.thumbnailId);
    this.renderActiveThumbnail(thumbnail.dataset.thumbnailId);
  },
  async addItemToCart(e) {
    var _a;
    e.preventDefault();
    const params = new URLSearchParams(window.location.search);
    const paramsVariantId = params.get("variant");
    const quantity = parseInt((_a = document.querySelector("#Quantity")) == null ? void 0 : _a.value);
    const hasVariants = this.product.variants.length > 1;
    const canAddToCart = await this.enforceMaxCart(quantity != null ? quantity : 1);
    if (!canAddToCart) {
      return alert(
        `So sorry. We're uable to sell more than ${this.cartMax} of this product at a time. We're unable to add this to the cart.`
      );
    }
    let variant = null;
    if (hasVariants) {
      if (!paramsVariantId) {
        return alert("No choice made, select a product from the options below");
      }
      const foundVariant = this.product.variants.find(
        ({ id }) => id === parseInt(paramsVariantId)
      );
      if (!foundVariant)
        return alert("Something went wrong");
      variant = foundVariant;
    } else {
      variant = this.product.variants[0];
    }
    const data = {
      items: [
        {
          id: variant.id,
          quantity: quantity != null ? quantity : 1,
          properties: __spreadValues({
            _sku: variant.sku
          }, this.cartMax && { "_cart-max": this.cartMax })
        }
      ]
    };
    $.post({
      url: "/cart/add.js",
      data,
      dataType: "json"
    }).done(
      function(item) {
        Box.Application.broadcast("cart-open");
      }.bind(this)
    ).fail(
      function(response) {
        console.log(response);
      }.bind(this)
    );
  },
  onThumbnailKeyup(event) {
    if (event.keyCode !== keyboardKeys.ENTER || !event.target.closest(selectors2.thumbnail)) {
      return;
    }
    const visibleFeaturedImageWrapper = this.container.querySelector(
      selectors2.visibleImageWrapper
    );
    forceFocus(visibleFeaturedImageWrapper);
  },
  renderSubmitButton(variant) {
    const submitButton = this.container.querySelector(selectors2.submitButton);
    const submitButtonText = this.container.querySelector(
      selectors2.submitButtonText
    );
    if (!variant) {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.unavailable;
    } else if (variant.available) {
      submitButton.disabled = false;
      submitButtonText.innerText = theme.strings.addToCart;
    } else {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.soldOut;
    }
  },
  renderImages(variant) {
    if (!variant || variant.featured_image === null) {
      return;
    }
    this.renderFeaturedImage(variant.featured_image.id);
    this.renderActiveThumbnail(variant.featured_image.id);
  },
  renderPrice(variant) {
    const priceElement = this.container.querySelector(selectors2.productPrice);
    const priceWrapperElement = this.container.querySelector(
      selectors2.priceWrapper
    );
    priceWrapperElement.classList.toggle(classes.hide, !variant);
    if (variant) {
      priceElement.innerText = (0, import_theme_currency.formatMoney)(variant.price, theme.moneyFormat);
    }
  },
  renderComparePrice(variant) {
    if (!variant) {
      return;
    }
    const comparePriceElement = this.container.querySelector(
      selectors2.comparePrice
    );
    const compareTextElement = this.container.querySelector(
      selectors2.comparePriceText
    );
    if (!comparePriceElement || !compareTextElement) {
      return;
    }
    if (variant.compare_at_price > variant.price) {
      comparePriceElement.innerText = (0, import_theme_currency.formatMoney)(
        variant.compare_at_price,
        theme.moneyFormat
      );
      compareTextElement.classList.remove(classes.hide);
      comparePriceElement.classList.remove(classes.hide);
    } else {
      comparePriceElement.innerText = "";
      compareTextElement.classList.add(classes.hide);
      comparePriceElement.classList.add(classes.hide);
    }
  },
  renderActiveThumbnail(id) {
    const activeThumbnail = this.container.querySelector(
      selectors2.thumbnailById(id)
    );
    const inactiveThumbnail = this.container.querySelector(
      selectors2.thumbnailActive
    );
    if (activeThumbnail === inactiveThumbnail) {
      return;
    }
    inactiveThumbnail.removeAttribute("aria-current");
    activeThumbnail.setAttribute("aria-current", true);
  },
  renderFeaturedImage(id) {
    const activeImage = this.container.querySelector(
      selectors2.visibleImageWrapper
    );
    const inactiveImage = this.container.querySelector(
      selectors2.imageWrapperById(id)
    );
    activeImage.classList.add(classes.hide);
    inactiveImage.classList.remove(classes.hide);
  },
  updateBrowserHistory(variant) {
    const enableHistoryState = this.productForm.element.dataset.enableHistoryState;
    if (!variant || enableHistoryState !== "true") {
      return;
    }
    const url = getUrlWithVariant(window.location.href, variant.id);
    window.history.replaceState({ path: url }, "", url);
  }
});
load("product");
